import BaseUseCase from "../../../base_use_case.js";

class ListSubscribersUseCase extends BaseUseCase {

  execute(identifier, params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/downloadables/downloadables/${identifier}/subscribers`,
      params: params
    }).then((result) => {
      let { data, headers } = result;
      let { subscribers } = data;

      subscribers = subscribers.map((subscriber) => {
        return {
          ...subscriber,
          key: subscriber.id,
          // itemLink: Routes.subscriber(subscriber)
        }
      })
      data.list = subscribers;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListSubscribersUseCase();
export default instance;
